let list = function() {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');
        fetch(global.route.classRoomIndividual, {
            headers: {'x-access-token': hash},
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('classroom indivudual list', responseJson);
                if (responseJson.status === "LIST_CLASSROOMS_INDIVIDUAL")
                    resolve(responseJson.list);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

let detail = function(id_classroom) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');
        fetch(global.route.classRoomIndividual + "/" + id_classroom, {
            headers: {'x-access-token': hash},
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('classroom individual detail', responseJson);
                if (responseJson.status === "DETAIL_CLASSROOM_INDIVIDUAL")
                    resolve(responseJson.classroom);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

let edit = function(object, id_classroom) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');

        fetch(global.route.classRoomIndividual + "/" + id_classroom, {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify({
                teacher_id: object.teacher_id,
                date_start: object.date_start,
                date_end: object.date_end,
                hours: object.hours,
                status: object.status
            })
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                 global.checkAuth(responseJson.status);
                console.log('classroom individual edit', responseJson);
                if (responseJson.status === "CLASSROOM_INDIVIDUAL_EDITED")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};


let createLessonIndividual = function(object) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');

        fetch(global.route.classRoomIndividualLesson, {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'PUT',
            body: JSON.stringify(object)
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('classroom individual lesson create', responseJson);
                if (responseJson.status === "CLASSROOM_LESSON_CREATED")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};


let editLessonIndividual = function(object) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');

        fetch(global.route.classRoomIndividualLesson, {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(object)
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('classroom individual lesson edit', responseJson);
                if (responseJson.status === "CLASSROOM_LESSON_EDITED")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

let deleteLessonIndividual = function(id) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');

        fetch(global.route.classRoomIndividualLesson, {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'DELETE',
            body: JSON.stringify({
                id: id
            })
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('classroom individual lesson delete', responseJson);
                if (responseJson.status === "CLASSROOM_LESSON_DELETED")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

let checkInLessonIndividual = function(id_lesson) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');
        fetch(global.route.classRoomIndividualLesson + "/" + id_lesson, {
            headers: {'x-access-token': hash},
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('classroom individual check in', responseJson);
                if (responseJson.status === "LESSON_CHECKIN_OK")
                    resolve(responseJson.url_lesson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

let createPostIndividual = function(object) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');

        fetch(global.route.classRoomIndividualPost, {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'PUT',
            body: JSON.stringify(object)
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('classroom individual post create', responseJson);
                if (responseJson.status === "CLASSROOM_POST_CREATED")
                    resolve(responseJson.id_post);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

let uploadPostFileIndividual = function(file, id) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');
        const formdata = new FormData();
        formdata.append('file', file)
        fetch(global.route.classRoomIndividualPostFile + '/' + id, {
            headers: {
                'x-access-token': hash,
                // 'Content-Type': 'application/json'
            },
            method: 'PUT',
            body: formdata
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('FILE_POST_UPLOAD_OK', responseJson);
                if (responseJson.status === "FILE_POST_UPLOAD_OK")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};
let streamPostFileIndividual = function(id_file) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');
        fetch(global.route.classRoomIndividualPostFile + "/" + id_file, {
            headers: {'x-access-token': hash},
            method: 'GET'
        })
            .then((response) => {
                if (response.status !== 500) {
                    return response.blob();
                } else {
                    throw new Error('Server response with status 500');
                }
            })
            .then((blob) => {
                let url = URL.createObjectURL(blob);
                resolve(url);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};


let editPostIndividual = function(object) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');

        fetch(global.route.classRoomIndividualPost, {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(object)
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('classroom individual post edit', responseJson);
                if (responseJson.status === "CLASSROOM_POST_EDITED")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

let deletePostIndividual = function(id) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');

        fetch(global.route.classRoomIndividualPost, {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'DELETE',
            body: JSON.stringify({
                id: id
            })
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('classroom individual post delete', responseJson);
                if (responseJson.status === "CLASSROOM_POST_DELETED")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

let complete = function(payload) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');

        fetch(global.route.classRoomIndividualComplete, {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(payload)
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('CLASSROOM INDIVIDUAL COMPLETE', responseJson);
                if (responseJson.status === "CLASSROOM_INDIVIDUAL_COMPLETED")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

let abandon = function(id_classroom_individual) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');

        fetch(global.route.classRoomIndividualAbandon, {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify({
                id_classroom_individual: id_classroom_individual
            })
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('CLASSROOM INDIVIDUAL ABANDON', responseJson);
                if (responseJson.status === "PARTECIPANT_ABANDONED" || responseJson.status === "ALREADY_ABANDONED")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

let markBoardSeenIndividual = function(id) {
    return new Promise(function(resolve, reject) {
        const hash = localStorage.getItem('hash');

        fetch(global.route.classRoomIndividualBoardSeen.replace('{id}', id), {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify({})
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                if (responseJson.status === "BOARD_MARKED_SEEN")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

/**
 * Presenze della classe individuale.
 *
 * Restituisce l'oggetto INTERO, non solo l'elenco: servono anche `present` e `total` per scrivere
 * «presente a 3 lezioni su 5» senza ricontarle nel componente. La gemella di gruppo
 * (`ClassRoomInsideAPI.detailAttendances`) risolve col solo elenco perche' li' quel riepilogo non
 * c'era; qui si parte con quello giusto.
 */
let detailAttendancesIndividual = function (id_classroom) {
    return new Promise(function (resolve, reject) {
        const hash = localStorage.getItem('hash');

        fetch(global.route.classRoomIndividualAttendance + '/' + id_classroom, {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log('classroom individual attendances', responseJson);
                if (responseJson.status === "DETAIL_ATTENDANCE")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

const classRoomIndividualAPI = {
    list: list,
    detail: detail,
    edit: edit,
    detailAttendancesIndividual: detailAttendancesIndividual,
    createLessonIndividual: createLessonIndividual,
    editLessonIndividual: editLessonIndividual,
    deleteLessonIndividual: deleteLessonIndividual,
    checkInLessonIndividual: checkInLessonIndividual,

    createPostIndividual: createPostIndividual,
    uploadPostFileIndividual: uploadPostFileIndividual,
    streamPostFileIndividual: streamPostFileIndividual,
    editPostIndividual: editPostIndividual,
    deletePostIndividual: deletePostIndividual,

    markBoardSeenIndividual: markBoardSeenIndividual,

    complete: complete,
    abandon: abandon,
};

module.exports = classRoomIndividualAPI;
